import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { addAttachmentsByDebtorIdAsync, approveDebtorByDebtorIdAsync, createContactPerson, createDebtorAsync, createDebtorSpecificationAsync, deleteContactPersonByIdAsync, deleteDebtorAttachmentAsync, deleteDebtorByIdAsync, deleteDebtorSpecificationAsync, disApproveDebtorByDebtorIdAsync, getAllApprovedDebtorsAsync, getAllAttachmentsByDebtorIdAsync, getAllDebtorSpecificationsbyDebtorIdAsync, getAllDebtorsAsync, getAllDisapprovedDebtorsAsync, getAllPendingDebtorsAsync, getContactPersonByIdAsync, getContactPersonsByDebtorIdAsync, getDebtorByIdAsync, getDebtorLinksCountByIdAsync, getDebtorNumberAsync, getDebtorSpecificationbyIdAsync, updateContactPersonAsync, updateDebtorAsync, updateDebtorSpecificationAsync } from './debtorThunk';
import { AppConsts } from '@application/common/constants/app-consts';
const debtorsRequest = {
    pageNumber: AppConsts.GRID_DEFAULT_PAGE_NUMBER,
    pageSize: AppConsts.GRID_DEFAULT_PAGE_SIZE
};
const initialState = {
    status: APIStatus.IDLE,
    debtorsRequest: debtorsRequest
};
export const debtorSlice = createSlice({
    name: 'debtor',
    initialState,
    reducers: {
        clearContactPerson: (state) => {
            state.contactPerson = null;
        },
        clearDebtorSpecification: (state) => {
            state.debtorSpecification = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllDebtorsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllDebtorsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.debtors = action.payload;
            state.debtorDropdown = action.payload.map((debtors) => {
                return {
                    label: `${debtors.name}`,
                    value: debtors.id,
                    number: `${debtors.debtorNumber}`
                };
            });
            state.activeDebtorDropdown = action.payload.filter(x => x.isApproved == true).map((debtors) => {
                return {
                    label: `${debtors.name}`,
                    value: debtors.id,
                    number: `${debtors.debtorNumber}`
                };
            });
        })
            .addCase(getAllDebtorsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createDebtorAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createDebtorAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.createdDebtor = action.payload;
        })
            .addCase(createDebtorAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getDebtorNumberAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getDebtorNumberAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.debtorNumber = action.payload;
        })
            .addCase(getDebtorNumberAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateDebtorAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateDebtorAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.updateDebtor = action.payload;
            state.unchangedDebtor = action.payload;
        })
            .addCase(updateDebtorAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllApprovedDebtorsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllApprovedDebtorsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.approvedDebtors = action.payload;
        })
            .addCase(getAllApprovedDebtorsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getDebtorByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getDebtorByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.updateDebtor = action.payload;
            state.debtor = action.payload;
            state.unchangedDebtor = action.payload;
        })
            .addCase(getDebtorByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllPendingDebtorsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllPendingDebtorsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.pendingDebtors = action.payload;
        })
            .addCase(getAllPendingDebtorsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createContactPerson.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createContactPerson.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.contactPerson = action.payload;
        })
            .addCase(createContactPerson.rejected, (state, action) => {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        });
        builder
            .addCase(getContactPersonsByDebtorIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getContactPersonsByDebtorIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.contactPersons = action.payload;
        })
            .addCase(getContactPersonsByDebtorIdAsync.rejected, (state, action) => {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        });
        builder
            .addCase(getContactPersonByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getContactPersonByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.contactPerson = action.payload;
        })
            .addCase(getContactPersonByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        });
        builder
            .addCase(updateContactPersonAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateContactPersonAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.contactPerson = action.payload;
        })
            .addCase(updateContactPersonAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteContactPersonByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteContactPersonByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(deleteContactPersonByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteDebtorByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteDebtorByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(deleteDebtorByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllAttachmentsByDebtorIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllAttachmentsByDebtorIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.debtorAttachments = action.payload;
        })
            .addCase(getAllAttachmentsByDebtorIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(addAttachmentsByDebtorIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(addAttachmentsByDebtorIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.uploadAttachment = action.payload;
        })
            .addCase(addAttachmentsByDebtorIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteDebtorAttachmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteDebtorAttachmentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.deleteAttachment = action.payload;
        })
            .addCase(deleteDebtorAttachmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(approveDebtorByDebtorIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(approveDebtorByDebtorIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(approveDebtorByDebtorIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createDebtorSpecificationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createDebtorSpecificationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.createdDebtorSpecification = action.payload;
        })
            .addCase(createDebtorSpecificationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllDebtorSpecificationsbyDebtorIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllDebtorSpecificationsbyDebtorIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.debtorSpecifications = action.payload;
        })
            .addCase(getAllDebtorSpecificationsbyDebtorIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getDebtorSpecificationbyIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getDebtorSpecificationbyIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.debtorSpecification = action.payload;
        })
            .addCase(getDebtorSpecificationbyIdAsync.rejected, (state, action) => {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        });
        builder
            .addCase(updateDebtorSpecificationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateDebtorSpecificationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.updatedebtorSpecification = action.payload;
        })
            .addCase(updateDebtorSpecificationAsync.rejected, (state, action) => {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        });
        builder
            .addCase(deleteDebtorSpecificationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteDebtorSpecificationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(deleteDebtorSpecificationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(disApproveDebtorByDebtorIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(disApproveDebtorByDebtorIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(disApproveDebtorByDebtorIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getDebtorLinksCountByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getDebtorLinksCountByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.debtorLinksCountonDisapprove = action.payload;
        })
            .addCase(getDebtorLinksCountByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllDisapprovedDebtorsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllDisapprovedDebtorsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.disapprovedDebtors = action.payload;
        })
            .addCase(getAllDisapprovedDebtorsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default debtorSlice.reducer;
export const { clearContactPerson, clearDebtorSpecification } = debtorSlice.actions;
